<template>
  <div>
    <div
      class="uk-input-left container uk-margin-remove"
    >
      <loading
        :active="isLoading"
        :is-full-page="true"
      />
      <div class="uk-margin-bottom">
        <h3 class="title">
          Valor Total de los Productos Enviados
        </h3>
        <p class="subtitle helper">
          INSTRUCCIONES: Favor seleccionar el modo de transporte del tramo internacional (Marítimo o Aéreo),
          la dirección del trayecto (Importación o Exportación), y el tipo de carga (Refrigerada o Seca).
        </p>
      </div>
      <div>
        <div>
          <div
            uk-grid
            class="uk-flex"
          >
            <section
              class="uk-width-1-2 costAndTases"
            >
              <h4 class="title uk-margin-bottom">
                Valor de la Mercancía Enviada
              </h4>
              <div class="uk-flex uk-margin-right">
                <input
                  v-model="shippingFeatures.shipmentValue.value"
                  type="number"
                  class="uk-input uk-width-small"
                  min="0"
                  max="9999999"
                  @keydown="$helperPlugin.onlyDecimal($event)"
                  @mouseover="setMessageInformation('Introduzca el Valor de la Mercancía')"
                  @mouseleave="setMessageInformation()"
                >
                <div
                  class="uk-flex uk-flex-middle"
                  @mouseover="setMessageInformation('Seleccione el tipo de moneda')"
                  @mouseleave="setMessageInformation()"
                >
                  <label>{{ shippingFeatures.shipmentValue.unitMeasurement?.abbreviation }}</label>
                  <div class="div-margin-left">
                    <font-awesome-icon
                      class="icon-adress"
                      icon="caret-down"
                      style="font-size: 17px; cursor: pointer;"
                    />
                    <div
                      id="pallet"
                      style="width: 20%;"
                      uk-dropdown="mode: click"
                    >
                      <ul class="uk-nav uk-dropdown-nav uk-width-medium">
                        <li
                          v-for="value in currencies"
                          :key="value.id"
                          :value="value"
                          class="uk-active"
                          @click="shippingFeatures.shipmentValue.unitMeasurement = value; closeHide('pallet')"
                        >
                          <span style="cursor: pointer">{{ value.description }} </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section class="costAndTases">
              <h4 class="title uk-margin-bottom">
                Tasa de Conversión
              </h4>
              <div
                class="uk-flex "
                @mouseover="setMessageInformation('Ingrese el precio del dollar en pesos')"
                @mouseleave="setMessageInformation()"
              >
                <label
                  style="margin-bottom: 10px;"
                  class="uk-flex uk-flex-middle"
                ><strong>US $ =  &nbsp;</strong> </label>
                <div class="sideRight">
                  <input
                    v-model="shippingFeatures.dollarToDominicanPeso"
                    type="number"
                    class="uk-input uk-width-small unit-weight"
                    min="0"
                    max="999"
                    @keydown="$helperPlugin.onlyDecimal($event)"
                  >
                  <label class="uk-flex uk-flex-middle weight">&nbsp; Dominican pesos</label>
                </div>
              </div>
            </section>
          </div>
          <section class="uk-margin-top">
            <h4 class="title">
              Formato del Envío
            </h4>
            <div class="shipping-format">
              <section
                v-if="transportMode === transportModeTypeEnum.maritime"
                class="uk-margin-top"
              >
                <h6 class="subtitle">
                  Contenedor de 20'
                </h6>
                <div uk-grid>
                  <div
                    class="uk-width-1-2 uk-flex sideRight"
                    @mouseover="setMessageInformation('Introduzca el número de unidades de contenedores de 20')"
                    @mouseleave="setMessageInformation()"
                  >
                    <input
                      v-model="shippingFeatures.container20.units"
                      type="number"
                      class="uk-input uk-width-small unit-weight"
                      min="0"
                      max="999999"
                      @keydown="$helperPlugin.onlyNumber($event)"
                    >
                    <label class="uk-flex uk-flex-middle weight"># Unidades</label>
                  </div>
                  <div
                    class="sideRight uk-width-1-2 uk-flex"
                    @mouseover="setMessageInformation('Introduzca el peso de la carga y el tipo de medida')"
                    @mouseleave="setMessageInformation()"
                  >
                    <input
                      v-model="shippingFeatures.container20.totalWeight.value"
                      type="number"
                      class="uk-input uk-width-small unit-weight"
                      min="0"
                      max="9999999"
                      @keydown="$helperPlugin.onlyDecimal($event)"
                    >
                    <div class="uk-flex uk-flex-middle weight">
                      <label>Peso total ({{ shippingFeatures.container20.totalWeight.unitMeasurement?.abbreviation }})</label>
                      <div class="div-margin-left">
                        <font-awesome-icon
                          class="icon-adress"
                          icon="caret-down"
                          style="font-size: 17px; cursor: pointer;"
                        />
                        <div
                          id="container20"
                          style="width: 20%;"
                          uk-dropdown="mode: click"
                        >
                          <ul class="uk-nav uk-dropdown-nav uk-width-medium">
                            <li
                              v-for="value in unitWeights"
                              :key="value"
                              :value="value"
                              class="uk-active"
                              @click="shippingFeatures.container20.totalWeight.unitMeasurement = value; closeHide('container20')"
                            >
                              <span style="cursor: pointer">{{ value.description }} </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                v-if="transportMode === transportModeTypeEnum.maritime"
                class="uk-margin-top"
              >
                <h6 class="subtitle">
                  Contenedor de 40'
                </h6>
                <div uk-grid>
                  <div
                    class="uk-width-1-2  uk-flex sideRight"
                    @mouseover="setMessageInformation('Introduzca el número de unidades de contenedores de 40')"
                    @mouseleave="setMessageInformation()"
                  >
                    <input
                      v-model="shippingFeatures.container40.units"
                      type="number"
                      class="uk-input uk-width-small unit-weight"
                      min="0"
                      max="999999"
                      @keydown="$helperPlugin.onlyNumber($event)"
                    >
                    <label class="uk-flex uk-flex-middle weight"># Unidades</label>
                  </div>
                  <div
                    class="sideRight uk-width-1-2 uk-flex"
                    @mouseover="setMessageInformation('Introduzca el peso de la carga y el tipo de medida')"
                    @mouseleave="setMessageInformation()"
                  >
                    <input
                      v-model="shippingFeatures.container40.totalWeight.value"
                      type="number"
                      class="uk-input uk-width-small unit-weight"
                      min="0"
                      max="9999999"
                      @keydown="$helperPlugin.onlyDecimal($event)"
                    >
                    <div class="uk-flex uk-flex-middle weight">
                      <label>Peso total ({{ shippingFeatures.container40.totalWeight.unitMeasurement?.abbreviation }})</label>
                      <div class="div-margin-left">
                        <font-awesome-icon
                          class="icon-adress"
                          icon="caret-down"
                          style="font-size: 17px; cursor: pointer;"
                        />
                        <div
                          id="container40"
                          style="width: 20%;"
                          uk-dropdown="mode: click"
                        >
                          <ul class="uk-nav uk-dropdown-nav uk-width-medium">
                            <li
                              v-for="value in unitWeights"
                              :key="value"
                              :value="value"
                              class="uk-active"
                              @click="shippingFeatures.container40.totalWeight.unitMeasurement = value; closeHide('container40')"
                            >
                              <span style="cursor: pointer">{{ value.description }} </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                v-if="transportMode === transportModeTypeEnum.maritime"
                class="uk-margin-top"
              >
                <h6 class="subtitle">
                  Contenedor de 45'
                </h6>
                <div uk-grid>
                  <div
                    class="uk-width-1-2  uk-flex sideRight"
                    @mouseover="setMessageInformation('Introduzca el número de unidades de contenedores de 45')"
                    @mouseleave="setMessageInformation()"
                  >
                    <input
                      v-model="shippingFeatures.container45.units"
                      type="number"
                      class="uk-input uk-width-small unit-weight"
                      min="0"
                      max="999999"
                      @keydown="$helperPlugin.onlyNumber($event)"
                    >
                    <label class="uk-flex uk-flex-middle weight weight"># Unidades</label>
                  </div>
                  <div
                    class="sideRight uk-width-1-2 uk-flex"
                    @mouseover="setMessageInformation('Introduzca el peso de la carga y el tipo de medida')"
                    @mouseleave="setMessageInformation()"
                  >
                    <input
                      v-model="shippingFeatures.container45.totalWeight.value"
                      type="number"
                      class="uk-input uk-width-small unit-weight"
                      min="0"
                      max="9999999"
                      @keydown="$helperPlugin.onlyDecimal($event)"
                    >
                    <div class="uk-flex uk-flex-middle weight">
                      <label>Peso total ({{ shippingFeatures.container45.totalWeight.unitMeasurement?.abbreviation }})</label>
                      <div class="div-margin-left">
                        <font-awesome-icon
                          class="icon-adress"
                          icon="caret-down"
                          style="font-size: 17px; cursor: pointer;"
                        />
                        <div
                          id="container45"
                          style="width: 20%;"
                          uk-dropdown="mode: click"
                        >
                          <ul class="uk-nav uk-dropdown-nav uk-width-medium">
                            <li
                              v-for="value in unitWeights"
                              :key="value"
                              :value="value"
                              class="uk-active"
                              @click="shippingFeatures.container45.totalWeight.unitMeasurement = value; closeHide('container45')"
                            >
                              <span style="cursor: pointer">{{ value.description }} </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                v-if="reeferOff"
                class="uk-margin-top"
              >
                <h6 class="subtitle">
                  Carga Paletizada
                </h6>
                <div uk-grid>
                  <div
                    class="uk-width-1-2 uk-flex sideRight"
                    @mouseover="setMessageInformation('Introduzca el número de unidades')"
                    @mouseleave="setMessageInformation()"
                  >
                    <input
                      v-model="shippingFeatures.pallets.units"
                      type="number"
                      class="uk-input uk-width-small unit-weight"
                      min="0"
                      max="9999999"
                      @keydown="$helperPlugin.onlyNumber($event)"
                    >
                    <label class="uk-flex uk-flex-middle weight weight"># Unidades</label>
                  </div>
                  <div
                    class="sideRight uk-width-1-2 uk-flex"
                    @mouseover="setMessageInformation('Introduzca el peso de la carga y el tipo de medida')"
                    @mouseleave="setMessageInformation()"
                  >
                    <input
                      v-model="shippingFeatures.pallets.totalWeight.value"
                      type="number"
                      class="uk-input uk-width-small unit-weight"
                      min="0"
                      max="9999999"
                      @keydown="$helperPlugin.onlyDecimal($event)"
                    >
                    <div class="uk-flex uk-flex-middle weight">
                      <label>Peso total ({{ shippingFeatures.pallets.totalWeight.unitMeasurement?.abbreviation }})</label>
                      <div class="div-margin-left">
                        <font-awesome-icon
                          class="icon-adress"
                          icon="caret-down"
                          style="font-size: 17px; cursor: pointer;"
                        />
                        <div
                          id="pallets"
                          style="width: 20%;"
                          uk-dropdown="mode: click"
                        >
                          <ul class="uk-nav uk-dropdown-nav uk-width-medium">
                            <li
                              v-for="value in unitWeights"
                              :key="value"
                              :value="value"
                              class="uk-active"
                              @click="shippingFeatures.pallets.totalWeight.unitMeasurement = value; closeHide('pallets')"
                            >
                              <span style="cursor: pointer">{{ value.description }} </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </section>
        </div>
      </div>
    </div>
    <wizard-button
      :data="info"
      @click="updatingStore"
    />
  </div>
</template>

<script>
import { transportModeTypeEnum, dollyTypeEnum, directionTypeEnum } from '../../../types'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      transportModeTypeEnum,
      dollyTypeEnum,
      directionTypeEnum,
      reeferOff: null,
      disabledContainer: null,

      isLoading: false,
      shippingFeatures: {
        dollarToDominicanPeso: null,
        shipmentValue: {
          value: null,
          unitMeasurement: null
        },
        container20:
          {
            units: null,
            totalWeight: {
              value: null,
              unitMeasurement: null
            }
          },
        container40:
          {
            units: null,
            totalWeight: {
              value: null,
              unitMeasurement: null
            }
          },
        container45:
          {
            units: null,
            totalWeight: {
              value: null,
              unitMeasurement: null
            }
          },
        pallets:
          {
            units: null,
            totalWeight: {
              value: null,
              unitMeasurement: null
            }
          }
      },
      weightUnitDictionary: new Map(),
      volumeUnitDictionary: new Map(),
      unitWeights: [],
      unitVolumes: [],
      currencies: [
        { id: 1, description: 'Peso Dominicanos', abbreviation: 'DOP' },
        { id: 2, description: 'Dolar Estadounidense', abbreviation: 'USD' }
      ],
      informationMsg: {
        image: null,
        message: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'storeShippingFeatures',
      'transportMode',
      'dollyType',
      'journeyDirection'
    ]),
    info: function () {
      const countContainers = this.getNumber(this.shippingFeatures.container20.units) + this.getNumber(this.shippingFeatures.container40.units) + this.getNumber(this.shippingFeatures.container45.units) + this.getNumber(this.shippingFeatures.pallets.units)
      const countWeights = this.getNumber(this.shippingFeatures.container20?.totalWeight?.value) + this.getNumber(this.shippingFeatures.container40?.totalWeight?.value) + this.getNumber(this.shippingFeatures.container45?.totalWeight?.value) + this.getNumber(this.shippingFeatures.pallets?.totalWeight?.value)
      if (this.shippingFeatures?.shipmentValue?.value && this.shippingFeatures.dollarToDominicanPeso) {
        return {
          shipmentValue: this.shippingFeatures?.shipmentValue?.value,
          dollarToDominicanPeso: this.shippingFeatures.dollarToDominicanPeso,
          countContainers: countContainers && countContainers > 0 ? countContainers : null,
          countWeights: countWeights && countWeights > 0 ? countWeights : null
        }
      } else {
        return {
          isValid: null
        }
      }
    }
  },
  watch: {

    'shippingFeatures.dollarToDominicanPeso': async function (newVal, oldVal) {
      if (newVal > 999) {
        this.shippingFeatures.dollarToDominicanPeso = oldVal
      }
      oldVal = this.shippingFeatures.dollarToDominicanPeso
    },
    'shippingFeatures.pallets.totalWeight.unitMeasurement': async function (newVal, oldVal) {
      if (oldVal) {
        this.shippingFeatures.pallets.totalWeight.value = this.convert(this.shippingFeatures.pallets.totalWeight.value, this.weightUnitDictionary?.get(oldVal.abbreviation), this.weightUnitDictionary?.get(newVal.abbreviation))
      }
    },
    'shippingFeatures.container20.totalWeight.unitMeasurement': async function (newVal, oldVal) {
      if (oldVal) {
        this.shippingFeatures.container20.totalWeight.value = this.convert(this.shippingFeatures.container20.totalWeight.value, this.weightUnitDictionary?.get(oldVal.abbreviation), this.weightUnitDictionary?.get(newVal.abbreviation))
      }
    },
    'shippingFeatures.container40.totalWeight.unitMeasurement': async function (newVal, oldVal) {
      if (oldVal) {
        this.shippingFeatures.container40.totalWeight.value = this.convert(this.shippingFeatures.container40.totalWeight.value, this.weightUnitDictionary?.get(oldVal.abbreviation), this.weightUnitDictionary?.get(newVal.abbreviation))
      }
    },
    'shippingFeatures.container45.totalWeight.unitMeasurement': async function (newVal, oldVal) {
      if (oldVal) {
        this.shippingFeatures.container45.totalWeight.value = this.convert(this.shippingFeatures.container45.totalWeight.value, this.weightUnitDictionary?.get(oldVal.abbreviation), this.weightUnitDictionary?.get(newVal.abbreviation))
      }
    },
    'shippingFeatures.pallets.units': async function (newVal, oldVal) {
      if (this.shippingFeatures.pallets.totalWeight.unitMeasurement.abbreviation === 'kg') {
        this.shippingFeatures.pallets.totalWeight.value = newVal * 830
      } else {
        this.shippingFeatures.pallets.totalWeight.value = newVal * 830 / 1000
      }
    },
    'shippingFeatures.container20.units': async function (newVal, oldVal) {
      if (this.shippingFeatures.container20.totalWeight.unitMeasurement.abbreviation === 'tm') {
        this.shippingFeatures.container20.totalWeight.value = newVal * 12
      } else {
        this.shippingFeatures.container20.totalWeight.value = newVal * 12 * 1000
      }
      if (this.shippingFeatures.container20.units > 999999) {
        this.shippingFeatures.container20.units = oldVal
      }
    },
    'shippingFeatures.container40.units': function (newVal, oldVal) {
      if (this.shippingFeatures.container40.totalWeight.unitMeasurement.abbreviation === 'tm') {
        this.shippingFeatures.container40.totalWeight.value = newVal * 24
      } else {
        this.shippingFeatures.container40.totalWeight.value = newVal * 24 * 1000
      }
      if (this.shippingFeatures.container40.units > 999999) this.shippingFeatures.container40.units = oldVal
    },
    'shippingFeatures.container45.units': function (newVal, oldVal) {
      if (this.shippingFeatures.container45.totalWeight.unitMeasurement.abbreviation === 'tm') {
        this.shippingFeatures.container45.totalWeight.value = newVal * 28
      } else {
        this.shippingFeatures.container45.totalWeight.value = newVal * 28 * 1000
      }
      if (this.shippingFeatures.container45.units > 999999) this.shippingFeatures.container45.units = oldVal
    },
    'shippingFeatures.shipmentValue.value': async function (newVal, oldVal) {
      if (this.shippingFeatures.shipmentValue.value > 999999) this.shippingFeatures.shipmentValue.value = oldVal
    }
  },
  beforeMount () {
    this.weightUnitDictionary.set('kg', 0.001) // kilogramo
    this.weightUnitDictionary.set('tm', 0.000001) // tonelada
    this.weightUnitDictionary.set('g', 1) // gramo
    this.weightUnitDictionary.set('mg', 1000) // miligramo

    this.volumeUnitDictionary.set('m3', 1) // volumen
  },

  async mounted () {
    await this.init()
    this.shippingFeatures = JSON.parse(JSON.stringify(this.storeShippingFeatures))
    this.setDefaultValues()
    this.isReefer()
    this.shippingFeatures.container20.totalWeight.value = this.storeShippingFeatures.container20.totalWeight.value
    this.shippingFeatures.container40.totalWeight.value = this.storeShippingFeatures.container40.totalWeight.value
    this.shippingFeatures.container45.totalWeight.value = this.storeShippingFeatures.container45.totalWeight.value
    this.shippingFeatures.pallets.totalWeight.value = this.storeShippingFeatures.pallets.totalWeight.value
    if (this.transportModeTypeEnum.aerial === this.transportMode) {
      this.disabledContainer = true
    }
  },
  methods: {
    getNumber (value) {
      if (value) return parseFloat(value)
      return 0
    },
    openShow (id) {
      UIkit.dropdown(`#${id}`).show() // eslint-disable-line
    },
    closeHide (id) {
      UIkit.dropdown(`#${id}`).hide(0)  // eslint-disable-line
    },
    async init () {
      try {
        this.isLoading = true
        this.unitWeights = await this.$services.unitsWeightService.getUnitWeights()
        this.unitVolumes = await this.$services.volumeUnitService.getUnitvolume()
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log(error)
        this.$toast.warning('No se pudo obtener los datos, contáctese con su administrador.', {
          position: 'top',
          duration: 4000
        })
      }
    },

    updatingStore () {
      this.$store.commit('setShippingFeatures', this.shippingFeatures)
    },
    setMessageInformation (message, image) {
      this.informationMsg.image = image
      this.informationMsg.message = message

      this.$store.commit('setMessageInformation', this.informationMsg)
    },
    setDefaultValues () {
      if (!this.shippingFeatures.pallets.totalWeight.unitMeasurement) {
        this.shippingFeatures.pallets.totalWeight.unitMeasurement = this.unitWeights.find(x => x.id === 2)
      }

      if (!this.shippingFeatures.container20.totalWeight.unitMeasurement) {
        this.shippingFeatures.container20.totalWeight.unitMeasurement = this.unitWeights.find(x => x.id === 1)
      }

      if (!this.shippingFeatures.container40.totalWeight.unitMeasurement) {
        this.shippingFeatures.container40.totalWeight.unitMeasurement = this.unitWeights.find(x => x.id === 1)
      }

      if (!this.shippingFeatures.container45.totalWeight.unitMeasurement) {
        this.shippingFeatures.container45.totalWeight.unitMeasurement = this.unitWeights.find(x => x.id === 1)
      }

      if (!this.shippingFeatures.shipmentValue.unitMeasurement) {
        this.shippingFeatures.shipmentValue.unitMeasurement = this.currencies.find(x => x.id === 1)
      }
    },
    convert (num, origin, destiny) {
      if (num) {
        num = num / origin * destiny
        num = parseFloat(num.toFixed(3))
        const isDecimal = num % 1 !== 0
        if (isDecimal) return num.toFixed(3)
        else return Math.round(num)
      }
      return 0
    },
    isReefer () {
      if (this.transportMode === this.transportModeTypeEnum.maritime && this.dollyType === this.dollyTypeEnum.reefer) {
        this.reeferOff = false
      } else {
        this.reeferOff = true
      }
    }
  }
}
</script>

<style scoped>

.div-margin-left {
  margin-left: 3px;
}
.uk-input{
  margin-right: 10px;
}
.weight{
  min-width: 120px;
}
.container{
  padding: 15px 40px;
  min-height: 418px;;
}
.costAndTases{
  flex-grow: 1
}
.vol-and-units{
  display: inline;

}
.labeltext {
  font-weight:600;
  color: #333 !important;
}
.uk-width-1-2{
  min-width: 150px !important;
}
p {

  margin: 10px;
}
.margin-label-input {
  margin: 20px 10px;
  width: 100%;
  font-weight: 600;

}
.title{
  font-weight: 600;
  margin-bottom: 10px;
}

.shippin-element{
  width: 55%;
}

.input-changes{
    width: 37%;
    margin: auto 5%;
    padding: 0px 5px;
}
.section-title {
 margin: 15px 0 1rem 0;
}

.helper{
  color:rgb(119 118 118 / 58%) !important;
  margin: 0px;
}
.sideRight{
  min-width: 200px;
}

@media screen and (max-width: 879px){
.sideRight{
  display: flex;
  flex-direction: column;
  min-width: 200px;
}
.weight{
  order: 1;
}
.unit-weight{
  order: 2;
}
  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .main{
    padding-top: 25px ;
  }
  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
  }
  .container{
    padding: 10px 20px;
  }
}
@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
}
</style>
